module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-modal', {
    attrs: {
      "visible": true,
      "title": _vm.title
    }
  }, [_c('div', {
    staticClass: "content coach-modal",
    class: [_vm.showPreview ? 'is-hidden' : ''],
    attrs: {
      "id": "modal-edit-content"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nome [PT]")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.name.pt),
      expression: "coach.name.pt"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Nome do Coche"
    },
    domProps: {
      "value": (_vm.coach.name.pt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.name.pt = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nome [EN]")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.name.en),
      expression: "coach.name.en"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Nome do Coche"
    },
    domProps: {
      "value": (_vm.coach.name.en)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.name.en = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nome [ES]")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.name.es),
      expression: "coach.name.es"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Nome do Coche"
    },
    domProps: {
      "value": (_vm.coach.name.es)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.name.es = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nome [FR]")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.name.fr),
      expression: "coach.name.fr"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Nome do Coche"
    },
    domProps: {
      "value": (_vm.coach.name.fr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.name.fr = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cor de Fundo")]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.background_color.hex),
      expression: "coach.background_color.hex"
    }],
    staticClass: "input is-expanded",
    attrs: {
      "type": "text",
      "placeholder": "Código de Cor (#HEX)",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.coach.background_color.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.background_color.hex = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    class: [_vm.colorPickerBtnTextBackground === 'Fechar' ? 'is-outlined' : ''],
    on: {
      "click": function($event) {
        _vm.toogleColorPicker('background')
      }
    }
  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextBackground))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('input', {
    staticClass: "input coach-color-preview",
    style: ({
      backgroundColor: _vm.coach.background_color.hex
    }),
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cor de Titulo + Texto do Menu")]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.title_color.hex),
      expression: "coach.title_color.hex"
    }],
    staticClass: "input is-expanded",
    attrs: {
      "type": "text",
      "placeholder": "Código de Cor (#HEX)",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.coach.title_color.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.title_color.hex = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    class: [_vm.colorPickerBtnTextTitle === 'Fechar' ? 'is-outlined' : ''],
    on: {
      "click": function($event) {
        _vm.toogleColorPicker('title')
      }
    }
  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('input', {
    staticClass: "input coach-color-preview",
    style: ({
      backgroundColor: _vm.coach.title_color.hex
    }),
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cor Botões Inactivos")]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.inactive_color.hex),
      expression: "coach.inactive_color.hex"
    }],
    staticClass: "input is-expanded",
    attrs: {
      "type": "text",
      "placeholder": "Código de Cor (#HEX)",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.coach.inactive_color.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.inactive_color.hex = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    class: [_vm.colorPickerBtnTextInactive === 'Fechar' ? 'is-outlined' : ''],
    on: {
      "click": function($event) {
        _vm.toogleColorPicker('inactive')
      }
    }
  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextInactive))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('input', {
    staticClass: "input coach-color-preview",
    style: ({
      backgroundColor: _vm.coach.inactive_color.hex
    }),
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cor Botões Activos")]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.active_color.hex),
      expression: "coach.active_color.hex"
    }],
    staticClass: "input is-expanded",
    attrs: {
      "type": "text",
      "placeholder": "Código de Cor (#HEX)",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.coach.active_color.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.active_color.hex = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    class: [_vm.colorPickerBtnTextActive === 'Fechar' ? 'is-outlined' : ''],
    on: {
      "click": function($event) {
        _vm.toogleColorPicker('active')
      }
    }
  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextActive))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('input', {
    staticClass: "input coach-color-preview",
    style: ({
      backgroundColor: _vm.coach.active_color.hex
    }),
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cor de Separadores do Menu")]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coach.filet_color.hex),
      expression: "coach.filet_color.hex"
    }],
    staticClass: "input is-expanded",
    attrs: {
      "type": "text",
      "placeholder": "Código de Cor (#HEX)",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.coach.filet_color.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coach.filet_color.hex = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    class: [_vm.colorPickerBtnTextFilet === 'Fechar' ? 'is-outlined' : ''],
    on: {
      "click": function($event) {
        _vm.toogleColorPicker('filet')
      }
    }
  }, [_vm._v(_vm._s(_vm.colorPickerBtnTextFilet))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('input', {
    staticClass: "input coach-color-preview",
    style: ({
      backgroundColor: _vm.coach.filet_color.hex
    }),
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])]), _vm._v(" "), _c('sketch-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showColorPicker),
      expression: "showColorPicker"
    }],
    class: 'color-picker-position-' + _vm.colorPickerPosition,
    on: {
      "input": _vm.onChangePickerColor
    },
    model: {
      value: (_vm.pickerColor),
      callback: function($$v) {
        _vm.pickerColor = $$v
      },
      expression: "pickerColor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Background "), _c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v("(1920x1080px)")])]), _vm._v(" "), (!_vm.newBackground && _vm.coach.background_image) ? _c('figure', {
    staticClass: "image is-16by9 coach-image fake-dropzone"
  }, [_c('img', {
    attrs: {
      "src": _vm.coach.background_image
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove",
    on: {
      "click": function($event) {
        _vm.showDropzone('background')
      }
    }
  }, [_vm._v("Remover")])]) : _c('p', {
    staticClass: "control"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom",
    attrs: {
      "id": "coachBackgroundDz",
      "url": _vm.dropzoneUploadUrl,
      "thumbnail-width": 286,
      "thumbnail-height": 161,
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadBackground,
      "vdropzone-removedfile": _vm.removeBackground
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Foreground "), _c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v("(1920x1080px)")])]), _vm._v(" "), (!_vm.newForeground && _vm.coach.foreground_image) ? _c('figure', {
    staticClass: "image is-16by9 coach-image fake-dropzone"
  }, [_c('img', {
    attrs: {
      "src": _vm.coach.foreground_image
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove",
    on: {
      "click": function($event) {
        _vm.showDropzone('foreground')
      }
    }
  }, [_vm._v("Remover")])]) : _c('p', {
    staticClass: "control"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom",
    attrs: {
      "id": "coachForegroundDz",
      "url": _vm.dropzoneUploadUrl,
      "thumbnail-width": 286,
      "thumbnail-height": 161,
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadForeground,
      "vdropzone-removedfile": _vm.removeForeground
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: [_vm.showPreview ? '' : 'is-hidden'],
    attrs: {
      "id": "modal-preview-content"
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewLanguage),
      expression: "previewLanguage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.previewLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v("PT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("FR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "coach-preview-image",
    attrs: {
      "onresize": "handleResize"
    }
  }, [_c('figure', {
    staticClass: "image",
    style: ({
      backgroundColor: _vm.coach.background_color.hex
    }),
    attrs: {
      "id": "coach-image-preview-container"
    }
  }, [_c('image-composite', {
    attrs: {
      "background": _vm.coach.background_image,
      "foreground": _vm.coach.foreground_image,
      "showLogo": true,
      "logoColor": _vm.backgroundLightness
    }
  })], 1)]), _vm._v(" "), (_vm.previewText) ? _c('div', {
    staticClass: "preview-coach-name",
    style: ({
      color: _vm.coach.title_color.hex,
      transform: _vm.textZoom,
      left: _vm.leftScale
    })
  }, [_vm._v(_vm._s(_vm.previewText))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "circle-container",
    style: ({
      transform: _vm.textZoom
    })
  }, [_c('div', {
    staticClass: "circle circle-home",
    style: (_vm.previewActiveStyle)
  }, [_c('span', {
    staticClass: "mnc mnc-MncApplicationFont_home"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle",
    style: ([_vm.isSelectedLanguage('pt') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
  }, [_c('span', {
    staticClass: "mnc mnc-MncApplicationFont_pt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle",
    style: ([_vm.isSelectedLanguage('en') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
  }, [_c('span', {
    staticClass: "mnc mnc-MncApplicationFont_en"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle",
    style: ([_vm.isSelectedLanguage('fr') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
  }, [_c('span', {
    staticClass: "mnc mnc-MncApplicationFont_fr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle",
    style: ([_vm.isSelectedLanguage('es') ? _vm.previewActiveStyle : _vm.previewInactiveStyle])
  }, [_c('span', {
    staticClass: "mnc mnc-MncApplicationFont_es"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container",
    style: ({
      transform: _vm.textZoom
    })
  }, [_c('div', {
    staticClass: "filet",
    style: ({
      background: _vm.coach.filet_color.hex
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-btn-container"
  }, [_c('div', {
    staticClass: "menu-btn-text",
    style: ({
      color: _vm.coach.title_color.hex
    })
  }, [_vm._v("TEXTO MENU")]), _vm._v(" "), _c('div', {
    staticClass: "circle",
    style: (_vm.previewInactiveStyle)
  }, [_c('span', {
    staticClass: "mnc mnc-MncApplicationFont_forward"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filet",
    style: ({
      background: _vm.coach.filet_color.hex
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-coach-name-warning"
  }, [_c('span', {
    staticClass: "preview-warning-text"
  }, [_c('b', [_vm._v("Aviso:")]), _vm._v(" " + _vm._s(_vm.previewWarning))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-600efce8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/CoachEditModal.vue
// module id = 325
// module chunks = 1